import { Stack } from "@mui/material";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { Button } from "Components/_Shared/Buttons/Button";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const Error400SignInPage: React.FunctionComponent = (_) => {
  const { t } = useResource();

  const signOut = useSignOut();

  return (
    <UnauthenticatedLayout title={"Error"}>
      <EmptyPage
        title={t(Resources.Errors.Error400SignIn.Title)}
        subtitle={t(Resources.Errors.Error400SignIn.Subtitle, { email: ANALYZER_EMAIL })}
        actions={
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={Spacing.L} mt={Spacing.XXL}>
            <Button onClick={() => signOut()}>{t(Resources.Errors.Error400SignIn.Button)}</Button>
          </Stack>
        }
      />
    </UnauthenticatedLayout>
  );
};
